import {
  ComplianceDocumentKind,
  ComplianceDocumentType,
} from '@texas/api/endpoints/metadata/complianceDocumentDefinitionsApi';
import { ensureEnumKey } from '@texas/utils/helpers/enumHelpers';
import { TFunction } from 'i18next';

export function complianceDocumentKindLabel(
  kind: ComplianceDocumentKind,
  t: TFunction,
) {
  const key = ensureEnumKey(
    ComplianceDocumentKind,
    kind,
  ) as unknown as keyof typeof ComplianceDocumentKind;
  return t(`complianceDocumentDefinitions.types.${key}`);
}

export function complianceDocumentTypeLabel(
  type: ComplianceDocumentType,
  t: TFunction,
) {
  const key = ensureEnumKey(
    ComplianceDocumentType,
    type,
  ) as unknown as keyof typeof ComplianceDocumentType;
  return t(`complianceDocumentDefinitions.type.${key}`);
}

export function complianceDocumentTypeHelp(
  type: ComplianceDocumentType,
  t: TFunction,
) {
  const key = ensureEnumKey(
    ComplianceDocumentType,
    type,
  ) as unknown as keyof typeof ComplianceDocumentType;
  return t(`complianceDocumentDefinitions.typeHelp.${key}`);
}
